<div class="d-flex container-fluid p-0 apiContainer" id="wrapper">
  <!-- Sidebar-->
  <div class="border-end bg-white" id="sidebar-wrapper">
    <span onclick="openNav()" class="openbtnIAG"><i class="fa fa-bars fa-lg"></i></span>
    <div class="list-group list-group-flush">
      <div id="mySidenav" class="sidenav">
        <div class="nav-header">
          <a href="javascript:void(0)" class="closebtnIAG" onclick="closeNav()">
            <i class="fa fa-bars fa-lg"></i>
          </a>
        </div>
        <div id="sideMenu-header" class="sideMenu-header">
          <a href="/home">
            <img class="sideMenu-logo logo3" [src]="configService.getLogo('BA_LOGO_MOBILE')" />
          </a>
        </div>
        <div class="sidebar-nav">
          <ul class="parent">
            <span class="notSubmenu">
              <a href="/" class="liclass">
                <span class="nav-text"><i class="fa fa-home fa-smx"></i>NDC Hub</span>
              </a>
            </span>

            <li *ngFor="let category of categories" [ngClass]="category?.subMenuIconClass ? 'submenu' : ''">
              <a class="liclass" (click)="category.url && setPageURL(category.url); setPageTitle(category.pageTitle || ''); closeNav()">
                <span class="nav-text"> <i [ngClass]="category.class ? category.class : ''"></i>{{ category.title }}</span>
              </a>

              <ul class="parent">
                <li *ngFor="let link of linkMap.get(category.title)" [ngClass]="link?.subMenuIconClass ? 'submenu' : ''">
                  <a
                    class="liclass"
                    (click)="
                      link.url && setPageURL(link.url);
                      setPageTitle(link.pageTitle || '');
                      setAPIName(link.apiName);
                      setAPITabs(link.apiTabs);
                      setAPITabsClass(link.apiTabsClass);
                      setIsTab(link.isTab);
                      closeNav()
                    "
                  >
                    <span class="nav-text"> <i [ngClass]="link.class"></i>{{ link.title }}</span>
                  </a>

                  <ul class="parent">
                    <li *ngFor="let reference of link.references" [ngClass]="reference?.subMenuIconClass ? 'submenu' : ''">
                      <a
                        class="liclass"
                        [href]="reference.href && reference.href === 'FlightShopping' ? '#' + reference.href : ''"
                        (click)="
                          reference.url && setPageURL(reference.url);
                          reference.pageTitle && setPageTitle(reference.pageTitle || '');
                          reference.apiName && setAPIName(reference.apiName);
                          reference.apiTabs && setAPITabs(reference.apiTabs);
                          reference.apiTabsClass && setAPITabsClass(reference.apiTabsClass);
                          setIsTab(reference.isTab);
                          reference.href && scrollToClass(reference.href || '');
                          closeNav()
                        "
                      >
                        <span class="nav-text"> <i [ngClass]="reference.class"></i>{{ reference.title }}</span>
                      </a>

                      <ul class="parent">
                        <li *ngFor="let subReference of reference.subReferences" [ngClass]="subReference?.subMenuIconClass ? 'submenu' : ''">
                          <a
                            class="liclass"
                            href="#{{ subReference.href }}"
                            (click)="
                              subReference.url && setPageURL(subReference.url);
                              setPageTitle(subReference.pageTitle || '');
                              setIsTab(subReference.isTab);
                              scrollToHref(subReference.href || '');
                              closeNav()
                            "
                          >
                            <span class="nav-text"> <i [ngClass]="subReference.class"></i>{{ subReference.title }}</span>
                          </a>

                          <ul class="parent">
                            <li *ngFor="let _subReference of subReference.subReferences">
                              <a class="liclass" href="#{{ _subReference.href }}" (click)="scrollToHref(_subReference.href || ''); closeNav()">
                                <span class="nav-text"> <i [ngClass]="_subReference.class"></i>{{ _subReference.title }}</span>
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <span class="notSubmenu">
              <a href="/sandbox" class="liclass">
                <span class="nav-text"><i class="fab fa-wpforms fa-smx"></i> Sandbox Tool</span>
              </a>
            </span>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="apiContainerRight">
    <app-revision-notices-page class="APiUpdatedPages" *ngIf="pageTitle.includes('RN-')" [pageTitle]="pageTitle"></app-revision-notices-page>
    <app-ndc-product-update-notifications-page *ngIf="pageTitle === 'NDC Product Update Notifications'"></app-ndc-product-update-notifications-page>
    <app-new-ndc-revision-notice-page *ngIf="pageTitle.includes('NR-')" [pageTitle]="pageTitle"></app-new-ndc-revision-notice-page>
    <app-getting-started-page *ngIf="pageTitle === 'Getting Started'"></app-getting-started-page>
    <app-introduction-to-ndc-page *ngIf="pageTitle === 'Introduction to NDC'"></app-introduction-to-ndc-page>
    <app-introduction-sandbox-tool-page *ngIf="pageTitle === 'Introduction - Sandbox Tool'"></app-introduction-sandbox-tool-page>
    <app-ndc-sandbox-tool-guide-page *ngIf="pageTitle === 'NDC SandBox Tool Guide'"></app-ndc-sandbox-tool-guide-page>
    <app-api-reference-v17dot2-page class="apiPage" *ngIf="pageTitle === 'API Reference 17.2'"></app-api-reference-v17dot2-page>

    <app-api-reference-page
      [isTabOverride]="isTabOverride"
      [selectedIndex]="selectedIndex"
      [isTab]="isTab"
      [apiTabs]="apiTabs"
      [apiTabsClass]="apiTabsClass"
      [pageTitle]="pageTitle"
      [apiName]="apiName"
      [tabName]="tabName"
      [href]="href"
      *ngIf="
        !pageTitle.includes('RN-') &&
        !pageTitle.includes('NR-') &&
        !pageTitle.includes('FileAssets') &&
        (pageTitle.includes('Overview') ||
          pageTitle.includes('Request') ||
          pageTitle.includes('Response') ||
          pageTitle.includes('XML Samples') ||
          pageTitle.includes('Error Responses') ||
          pageTitle.includes('Registration'))
      "
    ></app-api-reference-page>

    <app-functional-capabilities-offer-management-page
      [isTabOverride]="isTabOverride"
      [selectedIndex]="selectedIndex"
      [isTab]="isTab"
      [apiTabs]="apiTabs"
      [apiTabsClass]="apiTabsClass"
      [pageTitle]="pageTitle"
      [apiName]="apiName"
      [href]="href"
      *ngIf="pageTitle.includes('Offer Management ')"
    ></app-functional-capabilities-offer-management-page>

    <app-functional-capabilities-order-management-page
      [isTabOverride]="isTabOverride"
      [selectedIndex]="selectedIndex"
      [isTab]="isTab"
      [apiTabs]="apiTabs"
      [apiTabsClass]="apiTabsClass"
      [pageTitle]="pageTitle"
      [apiName]="apiName"
      [href]="href"
      *ngIf="pageTitle.includes('Order Management ') && !pageTitle.includes('FileAssets')"
    ></app-functional-capabilities-order-management-page>

    <app-functional-capabilities-disruption-handling-page
      [isTabOverride]="isTabOverride"
      [selectedIndex]="selectedIndex"
      [isTab]="isTab"
      [apiTabs]="apiTabs"
      [apiTabsClass]="apiTabsClass"
      [pageTitle]="pageTitle"
      [apiName]="apiName"
      [href]="href"
      *ngIf="pageTitle.includes('Disruption Handling ') && !pageTitle.includes('FileAssets')"
    ></app-functional-capabilities-disruption-handling-page>

    <app-file-assets-page *ngIf="pageTitle.includes('FileAssets-')" [pageTitle]="pageTitle"></app-file-assets-page>
    <app-common-types-datalists-page *ngIf="pageTitle.includes('CommonTypesDataLists-')" [pageTitle]="pageTitle"></app-common-types-datalists-page>
    <app-payments-page *ngIf="pageTitle === 'Payments'"></app-payments-page>
    <app-card-payment-authentication-page class="linkCssMob" *ngIf="pageTitle === 'Card Payment Authentication'" [href]="href"></app-card-payment-authentication-page>
    <app-languages-supported-page *ngIf="pageTitle === 'Languages supported'"></app-languages-supported-page>
    <app-test-credit-cards-page *ngIf="pageTitle === 'Test Credit Cards'"></app-test-credit-cards-page>
    <app-credit-card-authentication-page *ngIf="pageTitle === 'Credit Card Authentication'"></app-credit-card-authentication-page>
    <app-frequent-traveller-avios-cards-page *ngIf="pageTitle === 'Frequent Traveller Avios Cards'"></app-frequent-traveller-avios-cards-page>
    <app-functional-capabilities-ocn-authentication-page *ngIf="pageTitle === 'OrderChangeNotif Authentication'"></app-functional-capabilities-ocn-authentication-page>
  </div>
</div>
